/**
 * modal.js — cornerstone script, bundled into bundle.min.js via main.js
 * Provides modalTriggerFactory used by htmx_modal_with_trigger macro instances.
 */

function modalTriggerFactory(modalId, autoRefresh, closeOnSubmit) {
    return {
        modalOpen: false,
        autoRefresh,
        closeOnSubmit,
        eventListenerAttached: false,
        isRefreshing: false,

        init() {
            if (this.autoRefresh) this.setupAutoRefreshListener();
        },

        handleClose() {
            if (!this.closeOnSubmit && this.isRefreshing) return;
            this.modalOpen = false;
        },

        setupAutoRefreshListener() {
            if (this.eventListenerAttached) return;
            const content = document.getElementById(`htmx-modal-content-${modalId}`);
            if (!content) { setTimeout(() => this.setupAutoRefreshListener(), 100); return; }

            document.body.addEventListener('htmx:afterRequest', event => {
                if (content.contains(event.detail.target) &&
                    event.detail.target !== content &&
                    event.detail.successful) {
                    setTimeout(() => this.refreshModalContent(), 300);
                }
            });
            this.eventListenerAttached = true;
        },

        _getModalData() {
            const el = document.getElementById(`modal-data-${modalId}-json`);
            return el ? JSON.parse(el.textContent) : {};
        },

        openModalAndLoad() {
            this.modalOpen = true;
            const triggerEl = document.getElementById(`modal-trigger-${modalId}`);
            if (triggerEl) {
                triggerEl.setAttribute('hx-vals', JSON.stringify(this._getModalData()));
                htmx.trigger(triggerEl, 'click');
                if (this.autoRefresh && !this.eventListenerAttached) {
                    setTimeout(() => this.setupAutoRefreshListener(), 200);
                }
            }
        },

        refreshModalContent() {
            this.isRefreshing = true;
            const triggerEl = document.getElementById(`modal-trigger-${modalId}`);
            if (triggerEl) {
                triggerEl.setAttribute('hx-vals', JSON.stringify(this._getModalData()));
                htmx.trigger(triggerEl, 'click');
                setTimeout(() => { this.isRefreshing = false; }, 1000);
            }
        },
    };
}

window.modalTriggerFactory = modalTriggerFactory;
